import { render } from "./CourierForm.vue?vue&type=template&id=22bba460"
import script from "./CourierForm.vue?vue&type=script&lang=js"
export * from "./CourierForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/niteshdas/Projects/wordpress/wp-content/plugins/easy-restaurant-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__